module.exports = __webpack_public_path__ + "img/facebook.3f160e7f.svg";